import { neverHere } from "../tsHelpers";

export const toFriendlyName = (type: PlanningStage) => {
  switch (type) {
    case PlanningStage.InitialResearch:
      return "Just researching";
    case PlanningStage.MoreAdvice:
      return "Definitely want to go, need advice";
    case PlanningStage.ReadyToBook:
      return "Ready to book";
    default:
      neverHere(type);
  }
};

